// English content for the EN version of the site. Reuses GITES data for images/booking links.

export const BOOK_TOGETHER =
  "Travelling with family or friends? Chez Anne and Au 19 can be booked together to accommodate up to ten guests across two independent holiday cottages, with four bedrooms in total. Booking both cottages is subject to availability for the same dates. Contact Anne to discuss your stay.";

export const EN_NAV = [
  { path: "/en", label: "Home" },
  { path: "/en/cottages", label: "Our cottages" },
  { path: "/en/chez-anne", label: "Chez Anne" },
  { path: "/en/au-19", label: "Au 19" },
  { path: "/en/explore-burgundy", label: "Explore Burgundy" },
  { path: "/en/plan-your-stay", label: "Plan your stay" },
  { path: "/en/contact", label: "Contact" },
];

// FR <-> EN route mapping for the language switch and hreflang
export const FR_TO_EN = {
  "/": "/en",
  "/les-maisons": "/en/cottages",
  "/chez-anne-tanlay": "/en/chez-anne",
  "/au-19-tanlay": "/en/au-19",
  "/decouvrir-la-bourgogne": "/en/explore-burgundy",
  "/carnet-de-voyage-tanlay": "/en/tanlay-travel-journal",
  "/preparer-son-sejour": "/en/plan-your-stay",
  "/contact": "/en/contact",
  "/mentions-legales": "/en/legal-notice",
  "/politique-de-confidentialite": "/en/privacy-policy",
};
export const EN_TO_FR = {
  "/en": "/",
  "/en/cottages": "/les-maisons",
  "/en/chez-anne": "/chez-anne-tanlay",
  "/en/au-19": "/au-19-tanlay",
  "/en/explore-burgundy": "/decouvrir-la-bourgogne",
  "/en/tanlay-travel-journal": "/carnet-de-voyage-tanlay",
  "/en/plan-your-stay": "/preparer-son-sejour",
  "/en/contact": "/contact",
  "/en/legal-notice": "/mentions-legales",
  "/en/privacy-policy": "/politique-de-confidentialite",
};

export const EN = {
  brandPlace: "Tanlay · Burgundy",
  home: {
    heroTitle: ["Two holiday cottages.", "A different view", "of Burgundy."],
    ctaCottages: "Discover the cottages",
    ctaEmail: "Email Anne",
    overline: "Le Point de Vue de Tanlay",
    editorialTitle: "A place to fully experience Burgundy, for the length of a stay.",
    editorialText:
      "Here, the landscape sets the pace. Mornings begin on the terrace, the day unfolds along the canal or among the vines, and the evening brings you back to the warmth of a cottage chosen just for you.",
    subtitle:
      "In Tanlay, between château, canal and vineyards, two independent holiday cottages to slow down, breathe and rediscover the simple things.",
    cottagesOverline: "The cottages",
    viewCottage: "View the cottage",
  },
  cottages: {
    "chez-anne": {
      tagline: "A bright, generous cottage opening onto a large terrace and the landscape.",
      highlights: "Fireplace · Large terrace · Garden",
      description:
        "A bright 150 m² cottage bathed in light, extended by a vast terrace opening onto the whole valley. Two bedrooms, a living room with a fireplace and a leafy garden make up a peaceful place to set down your bags and take your time.",
      features: [
        "150 m²", "Sleeps up to five", "Two bedrooms", "One bathroom",
        "Fireplace", "Large terrace with valley view", "Leafy garden",
        "Fully equipped kitchen", "Walk-in Italian shower", "Free Wi-Fi", "Free private parking", "Pets welcome",
      ],
      galleryAlt: [
        "Flower-filled terrace with valley view", "Bright bedroom with large window", "Bedroom with double bed",
        "Living room with sofa", "Equipped kitchen", "Bathroom with shower", "Dining table", "Balcony with garden furniture",
      ],
    },
    "au-19": {
      tagline: "A characterful cottage, peaceful and independent, designed for getting together.",
      highlights: "Fireplace · Terrace · Garden",
      description:
        "A 120 m² cottage with spacious, light-filled rooms, a fireplace and a shower room with a walk-in Italian shower. Its terrace opens onto the Armançon valley and a leafy garden. A calm, independent place, a stone's throw from the village.",
      features: [
        "120 m²", "Sleeps up to five", "Two bedrooms", "Shower room with walk-in Italian shower",
        "Fireplace", "Terrace with Armançon valley view", "Leafy garden",
        "Fully equipped kitchen", "Free Wi-Fi", "Free private parking", "Pets welcome",
      ],
      galleryAlt: [
        "Bedroom with bed and desk", "Bedroom with view through the window", "Bedroom with French doors",
        "Living room with two sofas", "Kitchen with dining area", "Bathroom with shower",
        "Bathroom sink and mirror", "Terrace with panoramic view",
      ],
    },
  },
  house: {
    overline: "Le Point de Vue de Tanlay",
    reviews: "Read reviews on Booking →",
    features: "Features",
    bookTitle: "Book or request a stay",
    bookText: "Contact Anne directly, or book on Booking.",
    email: "Email Anne",
    call: "Call Anne",
    booking: "Book on Booking",
    gallery: "The cottage in pictures",
    bookCottage: (name) => `Book ${name} on Booking`,
  },
  contact: {
    overline: "Contact",
    title: "Request a stay",
    intro:
      "Write to or call Anne to check availability and plan your visit. You can also book directly on Booking.",
    email: "Email Anne",
    call: "Call Anne",
    bookingTitle: "Book on Booking",
    bookingOn: (name) => `${name} on Booking`,
  },
  footer: {
    place: "Tanlay · Burgundy",
    links: [
      { to: "/en", label: "Home" },
      { to: "/en/cottages", label: "Our cottages" },
      { to: "/en/chez-anne", label: "Chez Anne" },
      { to: "/en/au-19", label: "Au 19" },
      { to: "/en/explore-burgundy", label: "Explore Burgundy" },
      { to: "/en/plan-your-stay", label: "Plan your stay" },
      { to: "/en/contact", label: "Contact" },
    ],
    legal: "Legal notice",
    legalTo: "/en/legal-notice",
    privacy: "Privacy policy",
    privacyTo: "/en/privacy-policy",
    rights: "Holiday cottages in Tanlay, Burgundy · All rights reserved",
  },
  cottagesPage: {
    overline: "Our cottages",
    title: "Two independent cottages",
    subtitle: "Each with its own atmosphere, outlook and rhythm. Choose yours.",
    reviews: "Read reviews on Booking →",
    compare: (g) => `${g.sqm} m² · Sleeps up to ${g.guests} · ${g.bedrooms} bedrooms`,
    discover: (name) => `Discover ${name}`,
  },
  explore: {
    overline: "Discover",
    title: "Burgundy, at your own pace.",
    intro:
      "From Tanlay, set out to discover a quiet, little-known Burgundy of Renaissance châteaux, canal, vineyards and country lanes. Shape your stay freely, as you please.",
    groups: {
      Patrimoine: "Heritage",
      "Nature et mouvement": "Nature & movement",
      "Vignobles et art de vivre": "Vineyards & the good life",
    },
    discover: "Discover",
    inFrench: "(website in French)",
    disclaimer:
      "Atmospheric images. The links lead to the official websites of the places and activities shown.",
    ctaTitle: "Why not extend the experience?",
    ctaText: "Choose your cottage in Tanlay and picture your stay in the heart of Burgundy.",
    ctaChezAnne: "Discover Chez Anne",
    ctaAu19: "Discover Au 19",
    ctaChoose: "Choose my cottage",
    items: {
      "Le château de Tanlay": {
        title: "Château de Tanlay",
        alt: "Château de Tanlay in Burgundy",
        text: "A Renaissance gem surrounded by a moat, just minutes from the cottages.",
      },
      "Le château d'Ancy-le-Franc": {
        title: "Château d'Ancy-le-Franc",
        alt: "Château d'Ancy-le-Franc in Burgundy",
        text: "One of the finest Renaissance palaces in France, close by.",
      },
      "Le canal de Bourgogne": {
        title: "The Burgundy Canal",
        text: "To follow on foot, by bike or by boat, between locks and stone villages.",
      },
      "Promenades à pied et à vélo": {
        title: "Walking and cycling",
        text: "Paths, hillsides and canal banks: the area reveals itself with no fixed schedule.",
      },
      "Chablis et ses vignobles": {
        title: "Chablis and its vineyards",
        text: "The great white wines of Burgundy, to discover with local winemakers.",
      },
    },
  },
  plan: {
    overline: "Plan your stay",
    title: "The essentials before you come",
    intro:
      "Both cottages are located in Tanlay, in the Yonne, and are easily reached by car. For any specific question (access, dates, practical details), the simplest is to contact Anne directly.",
    infos: [
      { label: "Arrival", value: null },
      { label: "Departure", value: null },
      { label: "Languages spoken", value: "French · English · German" },
      { label: "Parking", value: "Free private parking on site" },
      { label: "Connection", value: "Free Wi-Fi" },
      { label: "Pets", value: "Allowed" },
    ],
    helpTitle: "A question? Write to or call Anne",
    email: "Email Anne",
    call: "Call Anne",
  },
  legal: {
    title: "Legal notice",
    editor: "Website publisher:",
    editorValue: "Le Point de Vue de Tanlay — Chez Anne · Au 19, Tanlay (Burgundy).",
    contact: "Contact:",
    content:
      "Photographs and accommodation content: Anne Yvois – Le Point de Vue de Tanlay. All rights reserved. The images in the “Explore Burgundy” section are atmospheric visuals.",
    booking: "Bookings can be made directly with Anne Yvois or via Booking.",
    creditsLabel: "Photo credits",
    credits:
      "“Explore Burgundy” section: Château de Tanlay © Myrabella / Wikimedia Commons (CC BY-SA 4.0); Château d'Ancy-le-Franc © Zairon / Wikimedia Commons (CC BY-SA 4.0).",
  },
  privacy: {
    title: "Privacy policy",
    p: [
      "This website has no collection form. Enquiries are made directly by phone or email to Anne.",
      "Technical data (IP address, connection logs, the “cf_clearance” security cookie) may be processed by the host for operation and security. The site loads fonts via Google Fonts, which may transmit your IP address to Google. Links to Booking, maps and tourist sites lead to third-party services with their own privacy policies.",
    ],
    contactSuffix:
      "The information you voluntarily send by email or phone is used solely to answer your stay request and is neither sold nor shared. For any question about your data, contact us at",
  },
};
